import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { toastManager } from "components/ToastNotification";
import Icon from "components/Icon";

const GlobalSearchInput = React.forwardRef(({
  onSearch,
  placeholder,
  id,
  dataCy
}, ref) => {
  const intl = useIntl();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch(searchText);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchText]);

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <div ref={ref} className="w-[300px] flex items-center px-5 py-2 mr-6 bg-white rounded-[100px] border border-[var(--color-gray-100)] tw-input-wrapper">
      <Icon name="search" size={20} className="text-[var(--color-gray-800)]" />
      <input
        id={id}
        data-cy={dataCy}
        type="text"
        className="tw-paragraph-reg ml-2 w-full outline-none"
        placeholder={placeholder}
        value={searchText}
        onChange={handleChange}
      />
    </div>
  );
});

export default GlobalSearchInput;